(() => {
  const {consentTitle, consentCustomize, consentDescription, consentPrivacy} = document.currentScript?.dataset ?? {};
  // Visitors touched by the retired shared bridge get one native shop-only choice.
  const legacyStampKey = 'sr_analytics_updated_at';
  let api = null;
  let needsLocalChoice = false;
  let requested = false;
  let explicitChoice = false;
  function requestLocalChoice() {
    if (!needsLocalChoice || requested || !api.shouldShowBanner?.() || !window.privacyBanner?.loadBanner) return;
    requested = true;
    try { Promise.resolve(window.privacyBanner.loadBanner({forceShow: true})).catch(() => {requested = false;}); }
    catch { requested = false; }
  }
  function styleBannerCopy() {
    requestLocalChoice();
    const manage = document.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (manage && consentCustomize && manage.textContent !== consentCustomize) manage.textContent = consentCustomize;
    const title = document.querySelector('#shopify-pc__banner h2');
    if (title && consentTitle && title.textContent !== consentTitle) title.textContent = consentTitle;
    const paragraph = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
    const privacyLink = paragraph?.querySelector('a');
    if (privacyLink && consentPrivacy && privacyLink.textContent !== consentPrivacy) privacyLink.textContent = consentPrivacy;
    if (privacyLink && consentDescription && paragraph.firstChild?.nodeValue !== `${consentDescription} `) {
      paragraph.replaceChildren(document.createTextNode(`${consentDescription} `), privacyLink);
    }
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-cookie-preferences]')) window.privacyBanner?.showPreferences?.();
    if (needsLocalChoice && event.target.closest('#shopify-pc__banner__btn-accept, #shopify-pc__banner__btn-decline, #shopify-pc__prefs__header-accept, #shopify-pc__prefs__header-decline, #shopify-pc__prefs__header-save')) explicitChoice = true;
  }, true);
  document.addEventListener('visitorConsentCollected', () => {
    if (!needsLocalChoice || !explicitChoice) return;
    explicitChoice = false;
    needsLocalChoice = false;
    try { api.setTrackingConsent({metafields: [{key: legacyStampKey, value: 'site-only'}]}, () => {}); }
    catch { /* Native consent remains valid; a later visit may ask once more. */ }
  });
  new MutationObserver(styleBannerCopy).observe(document.body, {childList: true, subtree: true});
  styleBannerCopy();
  window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], error => {
    if (error) return;
    api = window.Shopify.customerPrivacy;
    const stamp = api.getTrackingConsentMetafield?.(legacyStampKey);
    needsLocalChoice = Boolean(stamp && stamp !== 'site-only');
    requestLocalChoice();
  });
})();
